:host {
  color: var(--text-color-secondary, text-color('secondary'));
}

.orama-markdown-wrapper > :first-child {
  padding-top: 0;
  margin-top: 0;
}

p,
a,
li {
  font-size: var(--font-size-md, $font-size-md);
  line-height: var(--font-line-height-md, $font-line-height-m);
}

ul,
ol,
blockquote {
  margin: 0 0 var(--spacing-xs, $spacing-xs) var(--spacing-xs, $spacing-xs);
  padding: 0 0 0 var(--spacing-xs, $spacing-xs);
  padding-inline-start: var(--spacing-l, $spacing-l);
}

blockquote {
  border-left: var(--spacing-xs, $spacing-xs) solid var(--border-color-primary, border-color('primary'));
}

p > code {
  margin: 0 var(--spacing-xs, $spacing-xs);
}

pre > code {
  position: relative;
}

a {
  color: var(--text-color-primary, text-color('primary'));
  font-weight: bold;
  text-decoration: underline;
  opacity: 0.9;

  &:hover {
    opacity: 1;
  }
}

.orama-markdown-pre {
  position: relative;
}

.orama-markdown-code {
  border-radius: var(--radius-s, $radius-s);
}

.orama-markdown-code-title {
  display: block;
  font-size: var(--font-size-xxs, $font-size-xxs);
  color: var(--text-color-primary, text-color('primary'));
  padding: var(--spacing-s, $spacing-s) 0;
  opacity: 0.5;
}
